const TwitchIcon = (props) => {
  return (
    <svg
      width="100%"
      height="100%"
      stroke="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.39994 0.304688L0.809937 4.37469V20.6447H6.39994V23.6947H9.54994L12.5099 20.6447H17.0899L23.1899 14.6147V0.304688H2.39994ZM21.1499 13.5247L17.5899 17.0847H11.9999L8.94994 20.1347V17.0847H4.36994V2.34469H21.1499V13.5347V13.5247Z"
        fill="inherit"
      />
      <path
        d="M16.9799 7.01465H15.3199V12.0046H16.9799V7.01465Z"
        fill="inherit"
      />
      <path d="M11.99 7.01465H10.33V12.0046H11.99V7.01465Z" fill="inherit" />
    </svg>
  )
}

export default TwitchIcon
